import { SidebarWrapper } from '../SidebarWrapper'

export const SidebarStepViewFourth = () => {
  return <SidebarWrapper title={'Step 4'}>hola</SidebarWrapper>
}
